import { render, staticRenderFns } from "./GeoItemSearchComment.vue?vue&type=template&id=0fa0deb5&scoped=true"
import script from "./GeoItemSearchComment.vue?vue&type=script&lang=ts"
export * from "./GeoItemSearchComment.vue?vue&type=script&lang=ts"
import style0 from "./GeoItemSearchComment.vue?vue&type=style&index=0&id=0fa0deb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa0deb5",
  null
  
)

export default component.exports